import { render, staticRenderFns } from "./Precing.vue?vue&type=template&id=6c7631d0&scoped=true&"
import script from "./Precing.vue?vue&type=script&lang=js&"
export * from "./Precing.vue?vue&type=script&lang=js&"
import style0 from "./Precing.vue?vue&type=style&index=0&id=6c7631d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7631d0",
  null
  
)

export default component.exports